import { Box, styled } from "@mui/material";
import FlexBox from "components/flexbox/FlexBox";
import Scrollbar from "components/ScrollBar";
import LayoutDrawer from "layouts/layout-parts/LayoutDrawer";
import MultiLevelMenu from "./MultiLevelMenu";
import WrappedVersionLabel from "./WrappedVersionLabel";
import { useTheme } from "@mui/material";
import { getApplicationLogoPath } from "config/constants";

const TOP_HEADER_AREA = 70;
const NavWrapper = styled(Box)(() => ({
  paddingLeft: 16,
  paddingRight: 16,
  height: "100%",
}));
const StyledLogo = styled(Box)(() => ({
  paddingLeft: 8,
  fontWeight: 700,
  fontSize: 20,
}));

const MobileSidebar = (props) => {
  const theme = useTheme();
  const { sidebarCompact, showMobileSideBar, setShowMobileSideBar } = props;
  return (
    <LayoutDrawer open={showMobileSideBar} onClose={setShowMobileSideBar}>
      <Box p={2} maxHeight={TOP_HEADER_AREA}>
        <FlexBox ml={1.5}>
          <img src={getApplicationLogoPath(theme.palette.mode === "light")} alt="logo" width={40} />
          {/* <StyledLogo>UKO</StyledLogo> */}
        </FlexBox>
      </Box>

      <Scrollbar
        autoHide
        clickOnTrack={false}
        sx={{
          overflowX: "hidden",
          maxHeight: `calc(100vh - ${TOP_HEADER_AREA}px)`,
        }}
      >
        <NavWrapper compact={sidebarCompact}>
          <MultiLevelMenu sidebarCompact={false} />
        </NavWrapper>
      </Scrollbar>
      <Box sx={{
          position: "absolute",
          bottom: 0,
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}>
          <WrappedVersionLabel>Versión {localStorage.getItem("version")}</WrappedVersionLabel>
        </Box>
    </LayoutDrawer>
  );
};

export default MobileSidebar;
